import Box from '@/common/components/Box'
import Button from '@/common/components/Button'
import MaintenanceObjective from '@/common/components/MaintenanceObjective'
import { MaintenanceSolicitationValidationSchema } from '@/features/maintenanceSolicitations/schemas/create.schema'
import { XIcon } from 'lucide-react'
import { FieldArrayWithId, UseFieldArrayRemove } from 'react-hook-form'

interface MaintenanceSolicitationObjectivesProps {
  objectivesFields: FieldArrayWithId<MaintenanceSolicitationValidationSchema, 'objectives', 'id'>[]
  removeObjective: UseFieldArrayRemove
}

export const MaintenanceSolicitationObjectives = ({
  objectivesFields,
  removeObjective,
}: MaintenanceSolicitationObjectivesProps) => {
  return (
    <>
      {objectivesFields.map((field, index) => (
        <Box key={field.id} className="flex w-full items-start justify-between gap-2 rounded-lg">
          <MaintenanceObjective
            systemDisplayName={field.system_id.label as string}
            actionDisplayName={field.action_id.label as string}
            partDisplayName={field.part_id.label as string} 
          />

          <Button type="button" variant="outline-error" className="p-0" onClick={() => removeObjective(index)}>
            <XIcon strokeWidth={1} className="text-danger" />
          </Button>
        </Box>
      ))}
    </>
  )
}
